const tabCm = {
      "63 à 67": {
            "77 à 79": { numbersize: "80A", lettersize: "XS" },
            "79 à 81": { numbersize: "80B", lettersize: "XS" },
            "81 à 83": { numbersize: "80C", lettersize: "M" },
            "83 à 85": { numbersize: "80D", lettersize: "L" },
            "85 à 87": { numbersize: "80E", lettersize: "XL" },
            "87 à 89": { numbersize: "80F", lettersize: "XL ou XS+" },
            "89 à 91": { numbersize: "80G", lettersize: "XS+" },
      },
      "68 à 72": {
            "81 à 83": { numbersize: "85A", lettersize: "XS" },
            "83 à 85": { numbersize: "85B", lettersize: "S" },
            "85 à 87": { numbersize: "85C", lettersize: "M" },
            "87 à 89": { numbersize: "85D", lettersize: "L ou XS+" },
            "89 à 91": { numbersize: "85E", lettersize: "XL ou XS+" },
            "91 à 93": { numbersize: "85F", lettersize: "XL ou S+" },
            "93 à 95": { numbersize: "85G", lettersize: "S+" },
      },
      "73 à 77": {
            "87 à 89": { numbersize: "90A", lettersize: "M" },
            "89 à 91": { numbersize: "90B", lettersize: "L" },
            "91 à 93": { numbersize: "90C", lettersize: "XL" },
            "93 à 95": { numbersize: "90D", lettersize: "XL ou S+" },
            "95 à 97": { numbersize: "90E", lettersize: "XL ou S+" },
            "97 à 99": { numbersize: "90F", lettersize: "XL ou M+" },
            "99 à 101": { numbersize: "90G", lettersize: "M+" },
      },
      "78 à 82": {
            "91 à 93": { numbersize: "95A", lettersize: "S" },
            "93 à 95": { numbersize: "95B", lettersize: "M" },
            "95 à 97": { numbersize: "95C", lettersize: "L" },
            "97 à 99": { numbersize: "95D", lettersize: "XL ou L+" },
            "99 à 101": { numbersize: "95E", lettersize: "XL ou L+" },
            "101 à 103": { numbersize: "95F", lettersize: "XL ou L+" },
            "103 à 105": { numbersize: "95G", lettersize: "L+" },
      },
      "83 à 87": {
            "97 à 99": { numbersize: "100A", lettersize: "S" },
            "99 à 101": { numbersize: "100B", lettersize: "M" },
            "101 à 103": { numbersize: "100C", lettersize: "L" },
            "103 à 105": { numbersize: "100D", lettersize: "XL ou L+" },
            "105 à 107": { numbersize: "100E", lettersize: "XL ou L+" },
            "107 à 109": { numbersize: "100F", lettersize: "XL ou XL+" },
            "107 à 109": { numbersize: "100G", lettersize: "XL+" },
      },
      "88 à 92": {
            "101 à 103": { numbersize: "105A", lettersize: "S" },
            "103 à 105": { numbersize: "105B", lettersize: "M" },
            "105 à 107": { numbersize: "105C", lettersize: "L" },
            "107 à 109": { numbersize: "105D", lettersize: "XL ou XL+" },
            "109 à 111": { numbersize: "105E", lettersize: "XL ou XL+" },
            "111 à 113": { numbersize: "105F", lettersize: "XL ou 2XL+" },
            "113 à 115": { numbersize: "105G", lettersize: "2XL+" },
      },
      "93 à 97": {
            "107 à 109": { numbersize: "110A", lettersize: "" },
            "109 à 111": { numbersize: "110B", lettersize: "" },
            "111 à 113": { numbersize: "110C", lettersize: "" },
            "113 à 115": { numbersize: "110D", lettersize: "2XL+" },
            "115 à 117": { numbersize: "110E", lettersize: "2XL+" },
            "117 à 119": { numbersize: "110F", lettersize: "" },
            "119 à 121": { numbersize: "110G", lettersize: "" },
      },
};

// --------------- Tableau des bas en CM -----------------
const tabBasCm = {
      "84 - 88": {
            numbersize: "34",
            lettersize: "XXS"
      },
      "88 - 92": {
            numbersize: "36",
            lettersize: "XS"
      },
      "92 - 96": {
            numbersize: "38",
            lettersize: "S"
      },
      "96 - 100": {
            numbersize: "40",
            lettersize: "M"
      },
      "100 - 104": {
            numbersize: "42",
            lettersize: "L"
      },
      "104 - 108": {
            numbersize: "44",
            lettersize: "XL"
      },
      "108 - 112": {
            numbersize: "46",
            lettersize: "XXL"
      },
      "112 - 116": {
            numbersize: "48",
            lettersize: "XXXL"
      },
};

document.getElementById('bustSize').addEventListener('change', updateChestSizeOptions);
document.getElementById('findSizeButton').addEventListener('click', findSize);
document.getElementById('hipSize').addEventListener('change', updateHipSizeOptions);
document.getElementById('findBasSizeButton').addEventListener('click', findBasSize);
document.getElementById('addToCartButton').addEventListener('click', addToCart);

function updateChestSizeOptions() {
      const bustSize = document.getElementById('bustSize').value;
      const chestSizeSelect = document.getElementById('chestSize');
      chestSizeSelect.innerHTML = '<option value="">Sélectionnez</option>';

      if (tabCm[bustSize]) {
            Object.keys(tabCm[bustSize]).forEach(chestRange => {
                  const option = document.createElement('option');
                  option.value = chestRange;
                  option.text = chestRange;
                  chestSizeSelect.appendChild(option);
            });
      }
}

function findSize() {
      const bustSize = document.getElementById('bustSize').value;
      const chestSize = document.getElementById('chestSize').value;
      let found = false;
      let sizeResult = '';

      if (tabCm[bustSize] && tabCm[bustSize][chestSize]) {
            sizeResult = `Taille trouvée: ${tabCm[bustSize][chestSize].numbersize}, ${tabCm[bustSize][chestSize].lettersize}`;
            found = true;
      }

      if (found) {
            document.getElementById('content').style.display = 'none';
            document.getElementById('result').style.display = 'flex';
            document.getElementById('sizeResult').innerText = sizeResult;
            document.getElementById('result').scrollIntoView();
      } else {
            alert('Aucune taille trouvée pour les mesures fournies.');
      }
}

function updateHipSizeOptions() {
      const hipSize = document.getElementById('hipSize').value;
      // Mettre à jour les options si nécessaire
}

function findBasSize() {
      const hipSize = document.getElementById('hipSize').value;
      let found = false;
      let sizeResult = '';

      if (tabBasCm[hipSize]) {
            sizeResult = `Taille trouvée: ${tabBasCm[hipSize].numbersize}, ${tabBasCm[hipSize].lettersize}`;
            found = true;
      }

      if (found) {
            document.getElementById('content').style.display = 'none';
            document.getElementById('result').style.display = 'flex';
            document.getElementById('sizeResult').innerText = sizeResult;
            document.getElementById('result').scrollIntoView();
      } else {
            alert('Aucune taille trouvée pour les mesures fournies.');
      }
}

function addToCart() {
      alert('Ajouté au panier');
}

function addMeasurement(type) {
      var measurement;
      if (type === 'Culottes') {
            var hipSize = document.getElementById('hipSize').value;
            measurement = "Tour de bassin: " + hipSize;
      }

      var div = document.getElementById(type + 'Measurements');
      var p = document.createElement('p');
      p.classList.add('body-03');
      p.textContent = measurement;
      div.appendChild(p);
}
